import { format } from 'date-fns';
export default date => date == null || date == '' || date == '-' ? '' : format(new Date(date), 'dd.MM.yyyy');
// export default date => date == null || date == '' || date == '-' ? '' : format(new Date(date), 'dd.MM.yyyy');
